import { create } from 'zustand';

// We need to define our ActiveChat type to ensure type safety across components
export interface ActiveChat {
  specialistId: string;
  specialistName: string;
  caregiverId: string;
  caregiverName: string;
  roomId: string;
  specialistEmail?: string;
  caregiverEmail?: string;
  email?: string; // User's email (for backward compatibility)
}

interface ChatStore {
  activeChat: ActiveChat | null;
  setActiveChat: (chat: ActiveChat) => void;
  clearActiveChat: () => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  activeChat: null,
  setActiveChat: (chat) => set({ activeChat: chat }),
  clearActiveChat: () => set({ activeChat: null }),
}));
